if (typeof $ === "undefined") {
  $ = jQuery;
}

// debounce timeout
//webdesign.tutsplus.com/tutorials/javascript-debounce-and-throttle--cms-36783
let debounceTimer;

class app {
  constructor() {}

  init() {
    this.activateEventListeners();
    this.contactForm7Listeners();
    this.bsModals();
    this.handleVideos();
    this.loadMoreButton();
    this.findAProviderCallout();
    this.seePlanTreatPage();
    this.resultsPage();
  }

  debounce(callback, time) {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(callback, time);
  }

  activateEventListeners() {
    const app = this;

    /* GLOBAL: MISCELLANEA */

    /* READMORE / READLESS */
    $(".btn-readmore").on("click", function () {
      var circle = $(this).children(".circle");
      if (circle.length > 0) {
        var text_el = circle.next("span"); // Might or might not exist
        if (circle.hasClass("plus")) {
          circle.removeClass("plus").addClass("minus");
          if (text_el.length > 0) {
            text_el.text("Read Less");
          }
        } else {
          circle.removeClass("minus").addClass("plus");
          if (text_el.length > 0) {
            text_el.text("Read More");
          }
        }
      }
    });

    /* REVIEWS/MEDIA/VIDEO SWAP */

    // Smaller things you're supposed to click on to show a bigger one
    $(".nonvideo-teaser").on("click", function () {
      // visual feedback
      $(".nonvideo-teaser").removeClass("active");
      $(this).addClass("active");
      // nonvideo-[item->ID]
      var id = $(this).data("id");
      if (id.length === false) {
        return false;
      }
      var container_id = "nonvideo-full-" + id;
      // remove all, then target the current one
      $(".nonvideo-full").removeClass("active");
      $("#" + container_id).addClass("active");
    });

    /* MOBILE MENU / OFFCANVAS MENU */
    $('[data-toggle="offcanvas"], #navToggle').on("click", function () {
      $(".navbar-offcanvas").toggleClass("open");
    });

    /* ACTIVE STATES for MOBILE MENU */
    $(".nav-option").on("click", function (e) {
      if ($(this).hasClass("menu-item-has-children")) {
        e.preventDefault();
        var child = $(this).next(".nav-child");
        if (!$(this).hasClass("active")) {
          $(this).addClass("active");
          child.addClass("active");
          $(this).find(".arrow").removeClass("down").addClass("up");
        } else {
          $(this).removeClass("active");
          child.removeClass("active");
          $(this).find(".arrow").removeClass("up").addClass("down");
        }
      }
    });
    $(".nav-tabs .nav-item.disabled a").each(function () {
      $(this)
        .css("text-decoration", "none")
        .on("click", function (e) {
          e.preventDefault();
          return false;
        });
    });

    /* BOOTSTRAP CLASSES ADDED TO DESKTOP MENU (now with fun CSS icon arrows!)  */
    $("#navbar-desktop .primary-nav ul li.menu-item-has-children").each(
      function () {
        $(this).addClass("dropdown");
        $(this)
          .children("a")
          .append('<i class="arrow down"></i>')
          .attr({
            "data-toggle": "dropdown",
            role: "button",
            "aria-haspopup": "true",
            "aria-expanded": "false",
          })
          .next("ul")
          .addClass("dropdown-menu")
          .children("li")
          .addClass("dropdown-item");
      }
    );

    /* FACEBOOK SELFIE SIM TRACKING */
    $("#continue-button-start").on("click", function (e) {
      if (typeof fbq === "function") {
        fbq("track", "Lead", {
          content_name: "Selfie Simulator Start",
        });
      }
    });

    // Auto scroll or other listeners on click...
    $('a[href^="#"]').each(function () {
      $(this).on("click", function (e) {
        if ($(this).hasClass("hash-scroll")) {
          e.preventDefault();
          app.scrollToAnchor($(this));
        }
      });
    });

    // Make sure certain links don't work.  Ok then.
    $("a.unlink").on("click", function (e) {
      e.preventDefault();
    });
  }
  /* activateEventListeners END */

  scrollToAnchor(el, offset) {
    const app = this;

    if (!el.jquery) {
      el = $(el);
    }

    if (offset === null || offset === undefined) {
      offset = app.getScrollOffsetHeight();
      window.addEventListener("resize", (e) => {
        offset = app.debounce(app.getScrollOffsetHeight, 500);
      });
    }

    var id = el.attr("href");
    if (id.length > 0) {
      $("html, body").animate(
        {
          scrollTop: $(id).offset().top - offset,
        },
        600
      );

      // glow the article nav that's active
      var nav_container = el.closest(".article-nav");
      if (nav_container.length > 0) {
        nav_container.find("a").removeClass("on");
        el.addClass("on");
      }
    }
  }

  getScrollOffsetHeight() {
    // Get all fixed top elements' height
    var h = 0;
    if ($("#brand-bar").length > 0) h = h + 25;
    if ($("#navbar-mobile").length > 0)
      h = h + $("#navbar-mobile .fixed-top").height();
    if ($(".article-sticky").length > 0) h = h + $(".article-sticky").height();

    return h;
  }

  contactForm7Listeners() {
    /* CONTACT FORM 7: Validation Events for changing response CSS classes to Bootsrap classes */
    document.addEventListener(
      "wpcf7invalid",
      function (event) {
        $(".wpcf7-response-output").addClass("alert alert-danger");
      },
      false
    );
    document.addEventListener(
      "wpcf7spam",
      function (event) {
        $(".wpcf7-response-output").addClass("alert alert-warning");
      },
      false
    );
    document.addEventListener(
      "wpcf7mailfailed",
      function (event) {
        $(".wpcf7-response-output").addClass("alert alert-warning");
      },
      false
    );
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        $(".wpcf7-response-output").addClass("alert alert-success");
        if ($(".wpcf7-mail-sent-ok-custom").length > 0  && $('.modal').length > 0) {
          $(event.target)
            .hide()
            .closest(".modal")
            .find(".wpcf7-mail-sent-ok-custom")
            .show();
        }

        if ($(".wpcf7-mail-sent-ok-custom").length > 0 && $('#optin-physicians').length > 0 ){
          $(event.target).hide().closest('#optin-physicians').find('.wpcf7-mail-sent-ok-custom').show();
        }
      },
      false
    );

    /* CONTACT FORM 7: FIX for ignoring wpautop removal...? */
    $(".wpcf7-form p")
      .filter(function () {
        return $.trim(this.innerHTML) == "";
      })
      .remove();
    $(".wpcf7-form label br").remove();
  }

  bsModals() {
    /* BOOTSTRAP MODAL DIALOG HELPER(S) */

    // Basic usage is to add data attributes on anchor like:
    //    data-toggle="modal" data-target="#modal-optin-physicians"
    //    but if we want to trigger it from a WordPress nav link
    //    we have to add a css class called 'toggle-modal' in the WP nav menu
    //    but that will be on the 'li' element, but will let us delegate
    //    to the anchor with a little bit of custom javascript, below.
    //    The href attribute will be a fragment link of the modal's id tag...
    var toggle_modal = $(".toggle-modal");
    if (toggle_modal.length) {
      if (!toggle_modal.is("a")) {
        // if it's on a list element, like a wp menu nav item, a is the child
        toggle_modal = toggle_modal.children("a");
        toggle_modal
          .attr("data-toggle", "modal")
          .attr("data-modal", toggle_modal.attr("href"));
      }
    }

    // assume modal link is the element itself, like an image
    $(".open-modal").click(function (e) {
      e.preventDefault();
      var el = {};
      var caption = $(this).attr("title");

      // different data attributes do different things
      var iframe = $(this).data("iframe");
      var modal = $(this).data("modal");

      var classes = [];
      if (typeof iframe !== "undefined") {
        if (iframe === "video") {
          classes.push("modal-video");
        }
        var str = "";
        str += '<iframe src="' + $(this).attr("href") + '"';
        str +=
          'style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" scrolling="no">';
        str += "</iframe>";
        el = $(str);
        // do something when you close the modal
        $("#modal-generic").on("hidden.bs.modal", function () {
          // a video might still be playing, just get rid of it...
          $("#modal-generic .modal-body").html("");
        });
      } else if (typeof modal !== "undefined") {
        // link will open up existing div with the data value == id (without #)
        classes.push("modal-" + modal);
        el = $("#" + modal);
      } else {
        el = $(this).clone().removeClass("open-modal");
      }
      // we should have something to add to the modal body at this point
      if (el.length > 0) {
        $("#modal-generic .modal-body").html(el);
        $("#modal-generic .modal-title").text("");
        if (typeof caption !== "undefined" && caption.length > 0) {
          $("#modal-generic .modal-title").text(caption);
        }
        var str = classes.join(" ");
        $("#modal-generic").addClass(str).modal("show");
      }
    });
  }

  handleVideos() {
    const videos = $("video");
    videos.each(function (i) {
      // fade video out if it's got a background to fade to
      $(this).on("ended", function (e) {
        if ($(this).closest(".poster-background").length > 0) {
          $(this).fadeTo(1000, 0);
        }
      });
      // do something before data is loaded, loading spinner maybe...?
      //$(this).on('loadeddata', function(e) {
      //  if (this.readyState < 2) {
      //    //console.log('loading...');
      //  }
      //});

      // 'playing' event is fired when the video starts playing for the first time, after being paused or when restarting
      if (!this.hasAttribute("autoplay")) {
        $(this).on("playing", function (e) {
          // pause other videos when one starts
          videos.not(this).each(function (i, element) {
            if (!this.hasAttribute("autoplay")) {
              this.pause();
            }
          });
        });
      }
    });
  }

  findAProviderCallout() {
    /* FIND A PROVIDER CALLOUT */
    $(".find-a-provider-callout button").on("click", function (e) {
      e.preventDefault();
      var zip = $(this).closest(".find-a-provider-callout").find("input").val();
      if (zip !== "") {
        window.location = "/find-a-provider/?address=" + zip;
      } else {
        alert("Please Enter ZIP code, City, or State");
      }
      if (typeof fbq === "function") {
        fbq("track", "ViewContent", {
          content_name: "Find A Provider",
        });
      }
    });
  }


  loadMoreButton() {
    var itemsPerLoad = 3;
    var currentItems = {};

    $("#news-tabs-content .tab-pane ul").each(function () {
        var tabId = $(this).closest('.tab-pane').attr('id');
        currentItems[tabId] = itemsPerLoad;
        $(this).children("li:lt(" + itemsPerLoad + ")").slideDown();
    });

    function updateLoadMoreButton() {
        var active = $("#news-tabs-content .tab-pane.active");
        if (active.length === 1) {
            var activeId = active[0].id;
            var totalItems = $("#" + activeId + " li").length;
            var visibleItems = $("#" + activeId + " li:visible").length;

          if (visibleItems < totalItems) {
              $("#load-more-news").show();
          } else {
              $("#load-more-news").hide();
          }
        }
    }

    $('[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        var targetId = $(e.target).data('target').substring(1);
        if (!currentItems[targetId]) {
            currentItems[targetId] = itemsPerLoad;
        }
        updateLoadMoreButton();
    });

    $("#load-more-news").click(function () {
        var active = $("#news-tabs-content .tab-pane.active");
        if (active.length === 1) {
            var activeId = active[0].id;
            var totalItems = $("#" + activeId + " li").length;

            currentItems[activeId] = Math.min(currentItems[activeId] + itemsPerLoad, totalItems);
            $("#" + activeId + " li:lt(" + currentItems[activeId] + ")").slideDown();

            updateLoadMoreButton();
        }
    });

     $("#load-more-events").click(function () {
      var active = $("#events-tabs-content .tab-pane.active");
      if (active.length === 1) {
        var active_id = active[0].id;
        var n = $("#" + active_id + " li").length;
        x = x + 3 <= n ? x + 3 : n;
        $("#" + active_id + " li:lt(" + x + ")").slideDown();
        if (x === n) {
          $("#load-more-events").hide();
        }
      }
    });
}

  seePlanTreatPage() {
    // This is for the SeePlanTreat standalone page /seeplantreat
    var spt_cookie = Cookies.get("ultherapy_spt_form_completed");

    if (spt_cookie === undefined) {
      Cookies.set("ultherapy_spt_form_completed", "false", { expires: 365 });
    } else {
      if ($("#spt-form").length > 0) {
        if (spt_cookie === "true") {
          $("#spt-form").hide();
          $("#spt-course").show();
          var z = document.getElementById("spt-iframe");
          z.src = "/spt";
        } else {
          $("#spt-course").hide();
        }
      }
    }
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        // This is for the SeePlanTreat standalone page /seeplantreat
        if ($("#spt-form").length > 0) {
          $("#spt-form").hide();
          Cookies.set("ultherapy_spt_form_completed", "true", { expires: 365 });
          $("#spt-course").show();
          var z = document.getElementById("spt-iframe");
          z.src = "/spt";
        }
      },
      false
    );
  }

  resultsPage() {
    const app = this;

    // Showing what was clicked at top.  Almost like emulating a select, but using dropdown code.
    // Created a fake dropdown item at the top, then inserting the clicked button's html.
    $(".dropdown-custom a.dropdown-item").on("click", function (e) {
      e.preventDefault();
      if ($(this).hasClass("fake")) {
        return;
      }
      var fake = $(this).siblings(".fake");
      if (fake.length > 0) {
        fake.html($(this).html());
      }
      var switcheroo = $(this).closest(".media-switcheroo-js");
      // set before after media to the treatment clicked
      if (switcheroo.length > 0) {
        var tab = $(this).attr("href");
        tab = tab.substr(1);
        switcheroo.find(".media-wrapper").removeClass("active");
        switcheroo.find(".media-wrapper." + tab).addClass("active");
        // reset any buttons so the first item is active
        switcheroo
          .find(".controls a:first")
          .addClass("active")
          .siblings()
          .removeClass("active");
      }
    });

    $(".media-switcheroo-js input[type=radio]").on("change", function (e) {
      var switcheroo = $(this).closest(".media-switcheroo-js");
      var tab = $(this).val();
      switcheroo.find(".media-wrapper").removeClass("active");
      switcheroo.find(".media-wrapper." + tab).addClass("active");
      // reset any buttons so the first item is active
      switcheroo
        .find(".controls a:first")
        .addClass("active")
        .siblings()
        .removeClass("active");
    });

    // Shows image in 'active' blinder area based on index position.
    $(".result-blinder .controls a").on("click", function (e) {
      e.preventDefault();
      var i = $(this).index();
      $(this).addClass("active").siblings().removeClass("active");
      var activeImg = $(this)
        .closest(".result-blinder")
        .find(".media-wrapper.active img:eq(" + i + ")");
      activeImg.addClass("active").siblings().removeClass("active");
    });
  }
}

window.addEventListener("load", (e) => {
  const screen = new app();
  screen.init();
  $(".navbar.secondary-nav").delay(0).animate({ opacity: 1 }, 300);
  $(".navbar.primary-nav").delay(0).animate({ opacity: 1 }, 300);
});

//PLAY VIDEOS
document.addEventListener("DOMContentLoaded", function () {
  const desktopVideo = document.querySelector("#hero-video-desktop");
  const mobileVideo = document.querySelector("#hero-video-mobile");
  const singleVideo = document.querySelector("#hero-video");
  const multipleVideos = document.querySelectorAll(".hero-multiple-videos");
  const videoOverlays = document.querySelectorAll(".hero-video-overlay");
  
  videoOverlays.forEach(overlay => {
    const playButton = overlay.querySelector(".play-button");
    const parentContainer = overlay.closest(".hero-banner-video");
    const associatedVideo = parentContainer ? parentContainer.querySelector("video") : null;
    
    if (playButton && associatedVideo) {
      playButton.addEventListener("click", function () {
        overlay.classList.add("fade-out");
        playButton.style.display = "none";
        associatedVideo.play().catch(error => console.error("Error playing video:", error));
      });
    }
  });

  const allVideos = [desktopVideo, mobileVideo, singleVideo].filter(Boolean);
  multipleVideos.forEach(video => {
    if (video) allVideos.push(video);
  });

  // Add controls on hover to all videos
  allVideos.forEach(video => {
    const parentContainer = video.closest(".hero-banner-video");
    const relatedOverlay = parentContainer ? parentContainer.querySelector(".hero-video-overlay") : null;
    
    video.addEventListener("mouseover", () => video.setAttribute("controls", "controls"));
    video.addEventListener("mouseout", () => video.removeAttribute("controls"));
    
    if (relatedOverlay) {
      video.addEventListener("play", () => relatedOverlay.classList.add("fade-out"));
    }
  });
});

$(document).ready(function () {
  if ($(".carousel.slide").length > 0) {
    $(".carousel.slide").each(function (index, item) {
      var $item = $(item);
      var touchStartX = null;
      var touchEndX = null;

      $item.carousel({
        interval: false,
      });

      $item.on("touchstart", function (event) {
        touchStartX = event.originalEvent.touches[0].clientX;
      });

      $item.on("touchmove", function (event) {
        touchEndX = event.originalEvent.touches[0].clientX;
      });

      $item.on("touchend", function () {
        if (touchStartX && touchEndX) {
          var swipeDistance = touchStartX - touchEndX;
          if (swipeDistance > 50) {
            $item.carousel("next");
          } else if (swipeDistance < -50) {
            $item.carousel("prev");
          }
        }
        touchStartX = null;
        touchEndX = null;
      });
    });
  }
});

